// Picky Club custom.js restored: collection button overrides removed to keep product images stable.

// asset endpoint cache refresh 20260524T0109Z


/* Picky Club global product-card runtime guard. */
(function(){
  function cleanText(text){
    if (!text) return text;
    if (/agotado/i.test(text)) return 'Agotado';
    if (/vista\s+r.pida/i.test(text)) return '';
    if (/a(?:√±|‚àö¬±|√É¬±|\u00f1|\u00c3\u00b1)adir/i.test(text) || /^\+\s*\+/.test(text)) return '+ A' + '\u00f1' + 'adir';
    return text;
  }
  function run(){
    document.querySelectorAll('product-item, .product-item').forEach(function(card){
      card.querySelectorAll('.product-item__cta-wrapper').forEach(function(el){
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.style.setProperty('opacity','0','important');
        el.style.setProperty('pointer-events','none','important');
        el.style.setProperty('height','0','important');
        el.setAttribute('aria-hidden','true');
      });
      card.querySelectorAll('button, .button').forEach(function(el){
        var original = (el.textContent || '').trim();
        var next = cleanText(original);
        if (next === '') {
          el.style.setProperty('display','none','important');
          el.setAttribute('aria-hidden','true');
        } else if (next !== original) {
          el.textContent = next;
        }
        if (/agotado/i.test(next || original)) {
          el.textContent = 'Agotado';
          el.style.setProperty('background','#f4e8e3','important');
          el.style.setProperty('border','1px solid #b87365','important');
          el.style.setProperty('color','#6f342b','important');
          el.style.setProperty('box-shadow','none','important');
          el.style.setProperty('opacity','1','important');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('theme:loading:end', run);
  setTimeout(run, 100);
  setTimeout(run, 500);
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();


/* Picky Club soldout alignment runtime guard. */
(function(){
  function run(){
    document.querySelectorAll('.picky-card-cta__button--soldout').forEach(function(el){
      el.textContent = 'Agotado';
      el.style.setProperty('margin-top','12px','important');
      el.style.setProperty('height','52px','important');
      el.style.setProperty('min-height','52px','important');
      el.style.setProperty('max-height','52px','important');
      el.style.setProperty('padding','0','important');
      el.style.setProperty('display','inline-flex','important');
      el.style.setProperty('align-items','center','important');
      el.style.setProperty('justify-content','center','important');
      el.style.setProperty('line-height','1','important');
      el.style.setProperty('background','#f4e8e3','important');
      el.style.setProperty('border','1px solid #b87365','important');
      el.style.setProperty('color','#6f342b','important');
      el.style.setProperty('box-shadow','none','important');
      el.style.setProperty('opacity','1','important');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 200);
  setTimeout(run, 1000);
  setTimeout(run, 2500);
})();
